import * as React from 'react';
import * as Redux from 'redux';
import * as ReactRedux from 'react-redux';
import { TxDataUploadOptions } from './tx-data-upload-options';
import { IState, IUploadState } from '../../../interfaces';

export interface ITxDataUploadOptionsStateProps {
  readonly upload: IUploadState;
}

export type ITxDataUploadOptionsConnectProps = ITxDataUploadOptionsStateProps & ReactRedux.DispatchProp<Redux.Action>;

export function mapStateToProps(state: IState): ITxDataUploadOptionsStateProps {
  return { upload: state.upload };
}

export const TxDataUploadOptionsContainer: React.ComponentClass
  = ReactRedux.connect(mapStateToProps)(TxDataUploadOptions);
